import { connect } from 'react-redux'
import Priced from '../Components/Priced'
import { mapStateWithPriceToProps, mapDispatchToProps } from '../Utils/mapToProps'

export default connect(
  mapStateWithPriceToProps,
  mapDispatchToProps
)(Priced)
